module.exports = __webpack_public_path__ + "static/media/bms-logo.fd954cf5.png";